import { render, staticRenderFns } from "./pane.vue?vue&type=template&id=870a85d0&"
import script from "./pane.vue?vue&type=script&lang=js&"
export * from "./pane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports